// extracted by mini-css-extract-plugin
export default {"snackbar-container":"SnackbarContainer_snackbar-container__vipSk","snack":"SnackbarContainer_snack__kxkyi"};